import { SetStateAction } from 'jotai';

type SetAtom<Args extends any[], Result> = (...args: Args) => Result;

const getDeepomaticTaskgroupIndex = (
    deviceMac: string,
    deepomatic: (string | null)[]
): number => {
    return deepomatic.findIndex((e) => e === deviceMac);
};
const getDeepomaticTaskgroup = (
    deviceMac: string,
    taskgroup: string,
    deepomatic: (string | null)[]
) => {
    const idx = getDeepomaticTaskgroupIndex(deviceMac, deepomatic);
    if (idx === -1) {
        return false;
    }
    return `${taskgroup}_${idx + 1}`;
};

const checkAssignDeepomaticTaskgroupIdx = async (
    deviceMac: string,
    deepomatic: (string | null)[],
    setDeepomatic: SetAtom<[SetStateAction<(string | null)[]>], void>,
    updateDBState: SetAtom<[], Promise<void>>
) => {
    const idx = getDeepomaticTaskgroupIndex(deviceMac, deepomatic);
    if (idx === -1) {
        const firstAvailableTaskgroupIdx = deepomatic.findIndex(
            (e) => e === null
        );
        if (firstAvailableTaskgroupIdx !== -1) {
            const deepomaticCopy = [...deepomatic];
            deepomaticCopy[firstAvailableTaskgroupIdx] = deviceMac;
            setDeepomatic(deepomaticCopy);
            //update db to reflect updated deepomatic array
            await updateDBState();
        }
    }
};

const getDeepomaticPatchArray = (deepomatic: (string | null)[]): string[] => {
    const devicesWorkOrdersArray = deepomatic.map((e, idx) =>
        e === null ? null : `device_${idx + 1}`
    );
    return devicesWorkOrdersArray.filter((e): e is string => e !== null);
};

export {
    getDeepomaticTaskgroupIndex,
    getDeepomaticTaskgroup,
    checkAssignDeepomaticTaskgroupIdx,
    getDeepomaticPatchArray,
};
